<div class="info-page">
  <header class="info-hero">
    <p class="info-kicker">Host payouts</p>
    <h1 class="info-heading">Payment Policy</h1>
    <p class="info-sub">How LootLucky processes charges, host payouts, fees, and tax information.</p>
  </header>

  <div class="info-grid info-grid--two">
    <article class="info-card">
      <p class="info-updated">Last updated: September 18, 2026</p>
      <h2 class="info-block-title"><span class="info-icon info-icon--gold">1</span> Overview</h2>
      <p>This Payment Policy applies to hosts, buyers, and other users of LootLucky.com (the "Site"). By applying to host, accepting payouts, or purchasing seats, you agree to this policy together with our <a routerLink="/TermConditions">Terms &amp; Conditions</a>.</p>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--teal">2</span> How payments work</h2>
      <p>All prices are listed in U.S. dollars (USD) unless otherwise stated. Payments are processed by secure third-party payment processors. You authorize us and those processors to charge the payment method you provide for seats, fees, and other amounts due.</p>
      <p>We do not store full card numbers on our servers. Card data is handled by the payment gateway as described in our <a routerLink="/Policies">Privacy Policy</a>.</p>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--wine">3</span> Host payouts</h2>
      <p>Host earnings are paid only after a webinar is completed and settled, and after any applicable platform fees, refunds, chargebacks, shipping adjustments, and taxes are accounted for.</p>
      <ul>
        <li>Payout timing may vary based on processor settlement, banking holidays, and review of your account.</li>
        <li>We may hold, offset, or reverse payouts if we reasonably believe there is fraud, a dispute, a policy violation, or an unpaid amount owed to LootLucky or a buyer.</li>
        <li>You are responsible for providing accurate payout and tax details (including SSN or Tax ID where required).</li>
      </ul>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--purple">4</span> Fees, taxes, and records</h2>
      <p>Platform, processing, and other fees may be deducted from host proceeds. You are solely responsible for reporting and paying any taxes arising from your activity on the Site. LootLucky may issue tax forms where required by law.</p>
    </article>

    <article class="info-card info-card--alert">
      <h2 class="info-block-title"><span class="info-icon info-icon--coral">5</span> Chargebacks and errors</h2>
      <p>If a buyer initiates a chargeback or a payment is reversed, we may debit your host balance, withhold future payouts, or invoice you for the amount plus any processor fees. Report billing errors promptly through our <a routerLink="/Contact">Contact</a> page.</p>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--olive">6</span> Changes and contact</h2>
      <p>We may update this policy from time to time. Continued use of the Site after an update constitutes acceptance. If this policy conflicts with the Terms &amp; Conditions, the Terms control.</p>
      <a class="info-cta" routerLink="/Contact">Questions about payments</a>
    </article>
  </div>
</div>
